import { user, warningAlerts } from "../data/main";
import { getCurrentDate } from "../utilities/getCurrentDate";

export const warningWasShowed = (ter) => {
  return !ter || !warningAlerts[user.id]
    ? false
    : warningAlerts[user.id][ter] === getCurrentDate();
};

export const saveWarningSeen = (ter) => {
  if (ter) {
    if (!warningAlerts[user.id]) {
      warningAlerts[user.id] = {};
    }
    warningAlerts[user.id][ter] = getCurrentDate();
    localStorage.setItem("warningAlerts", JSON.stringify(warningAlerts));
  }
};

export const eventIsShowed = (id, date) => {
  return !warningAlerts[user.id] || !warningAlerts[user.id]?.events
    ? false
    : warningAlerts[user.id]?.events[id] === date;
};

export const saveEventSeen = ({ id, date }) => {
  try {
    if (!warningAlerts[user.id]) {
      warningAlerts[user.id] = {};
    }
    if (!warningAlerts[user.id].events) {
      warningAlerts[user.id].events = {};
    }
    if (warningAlerts[user.id].currentEvent !== getCurrentDate()) {
      warningAlerts[user.id].currentEvent = getCurrentDate();
      warningAlerts[user.id].events = {};
    }
    if (warningAlerts[user.id].events[id] !== date) {
      warningAlerts[user.id].events[id] = date;
    }
    localStorage.setItem("warningAlerts", JSON.stringify(warningAlerts));
  } catch (error) {
    console.log("saveEventSeen error: ", error);
  }
};
